export const INITIAL_STATE = {
  idToken: null,
  user: null,
  refreshTokenRequestSymbols: [],
  lastLoginSuccess: null,
};

export default {
  ...INITIAL_STATE,
};
